<template>
  <div id="Nbus_mainpage">
    <div class="nbus_container_1">
      <div>
        <img class="nbus_container_1_title" src="../assets/img/nbus_main/nbus_main_title.png" alt="">
        <div class="nbus_title_under_button1_wrap" @click="goToLink('link', 'nbus', '')">
          <span class="nbus_main_button_text">견적신청하기</span>
        </div>
      </div>
      <img class="nbus_jump_bus" src="../assets/img/nbus_main/nbus_bus.png" alt="">
      <img class="nbus_container_1_bg" src="../assets/img/nbus_main/nbus_main_titleback.jpg" alt="">
    </div>

    <div class="nbus_container_2">
  <!-- 떠 있는 이미지들 (절대 위치 고정) -->
  <img class="floating-object obj1" src="../assets/img/nbus_main/nbus_box_object_1.png" alt="">
  <img class="floating-object obj2" src="../assets/img/nbus_main/nbus_box_object_2.png" alt="">
  <img class="floating-object obj3" src="../assets/img/nbus_main/nbus_box_object_3.png" alt="">
  <img class="floating-object obj4" src="../assets/img/nbus_main/nbus_box_object_4.png" alt="">

  <img class="nbus_container_2_title" src="../assets/img/nbus_main/nbus_main_title2.png" alt="">

  <div class="nbus-box-container">
    <div class="nbus-box">
      <img src="../assets/img/nbus_main/nbus_box_1.jpg" alt="">
    </div>
    <div class="nbus-box">
      <img src="../assets/img/nbus_main/nbus_box_2.jpg" alt="">
    </div>
    <div class="nbus-box">
      <img src="../assets/img/nbus_main/nbus_box_3.jpg" alt="">
    </div>
    <div class="nbus-box">
      <img src="../assets/img/nbus_main/nbus_box_4.jpg" alt="">
    </div>
  </div>
</div>
<div class="nbus_container_3">
  <div class="nbus_container_3_left">
    <img class="nbus_box_pc" src="../assets/img/nbus_main/nbus_container_3_left.jpg" alt="">
    <img class="nbus_box_mo" src="../assets/img/nbus_main/nbus_container_3_left_mo.jpg" alt="">
    <div class="nbus_title_under_button2_wrap" @click="goToLink('link', 'nbus', '')">
          <span class="nbus_main_button_text">견적신청하기</span>
        </div>
        <img class="nbus_container_3_left2" src="../assets/img/nbus_main/nbus_container_3_left2.jpg" alt="">
  </div>
  
  <div class="nbus_container_3_right">

  </div>
</div>
<div class="nbus_container_4">
  <div class="nbus_container_4_inner">
    <img class="nbus_box_pc" src="../assets/img/nbus_main/nbus_container_4_title.jpg" alt="">
    <img class="nbus_box_mo" src="../assets/img/nbus_main/nbus_container_4_title_mo.jpg" alt="">
  </div>
  <div class="nbus_container_4_inner2">
    <div class="nbus-box2" @click="goToLink('link', 'shipTour', '')">
      <img class="nbus_box_pc" src="../assets/img/nbus_main/nbus_box_2-1.jpg" alt="">
      <img class="nbus_box_mo" src="../assets/img/nbus_main/nbus_box_3-1.jpg" alt="">
    </div>
    <div class="nbus-box2" @click="goToLink('link', 'bustour', '')">
      <img class="nbus_box_pc" src="../assets/img/nbus_main/nbus_box_2-2.jpg" alt="">
      <img class="nbus_box_mo" src="../assets/img/nbus_main/nbus_box_3-2.jpg" alt="">
    </div>
    <div class="nbus-box2" @click="goToLink('link', 'tktPass', '')">
      <img class="nbus_box_pc" src="../assets/img/nbus_main/nbus_box_2-3.jpg" alt="">
      <img class="nbus_box_mo" src="../assets/img/nbus_main/nbus_box_3-3.jpg" alt="">
    </div>
  </div>
</div>

<div class="nbus_main_footer">
  <div class="nbus_footer_center_img">
    <img class="nbus_box_pc" src="../assets/img/nbus_main/nbus_footer_text.png" alt="">
    <img class="nbus_box_mo" src="../assets/img/nbus_main/nbus_footer_text_mo.png" alt="">
  </div>
  <div class="nbus_title_under_button3_wrap" @click="goToLink('link', 'nbus', '')">
    <span class="nbus_main_button_text">견적신청하기</span>
  </div>
</div>
  </div>
</template>
  
<script>
export default {
  data(){},
  
  created() {
    //this.productId = this.$route.query.productId;
    this.user = this.$store.state.user;
  },
  
  computed: {
    user() {
      return this.$store.state.user;
    },    
  },

  mounted() {
    // // 스크롤 시 헤더 배경 & 로고 색상 변경 -> 단독 페이지 운용 시 사용할 헤더부분
    // const headerWrap = document.querySelector('.nbus_main_header_wrap');
    // const header = document.querySelector('.nbus_main_header');
    // const logo = document.querySelector('.nbus_main_logo');

    // window.addEventListener('scroll', () => {
    //   if (window.scrollY > 50) {
    //     headerWrap.classList.add('scrolled');
    //     header.classList.add('scrolled');
    //     logo.classList.add('scrolled');
    //   } else {
    //     headerWrap.classList.remove('scrolled');
    //     header.classList.remove('scrolled');
    //     logo.classList.remove('scrolled');
    //   }
    // });
  },

  methods: {
    goToLink(type, url) {
      // let sRoute = param
      if (type=== 'link') 
      {
        this.$router.push({ path: `/${url}`, query: {} });
      }
    },
  },
}
</script>
  
<style scoped>
@font-face {
    font-family: 'NanumHumanTTFBold';
    src: url('https://fastly.jsdelivr.net/gh/projectnoonnu/2501-1@1.1/NanumHumanTTFBold.woff2') format('woff2');
    font-weight: 700;
    font-style: normal;
}

#Nbus_mainpage {
  margin-top: -50px;
}

.nbus_jump_bus{
  position: absolute;
  width: 10%;
  bottom: 20px;
  right: 51%;
  z-index: 10;
  transform: translate(50%);
  animation: bus 2s ease-in-out infinite;
}
@keyframes bus {
  0%,10%,100%{
    transform: translate(50%) translateY(-8px);
  }
  10%,30%,50%,70%,90% {
    transform: translate(50%) translateY(0px);
  }
}
.nbus_main_header_wrap {
  position: fixed; /* 상단 고정 */
  top: 0;
  left: 0;
  width: 100%;
  height: 80px;
  background-color: #fff;
  z-index: 99999;
  box-shadow: 0 2px 5px rgba(0,0,0,0.1); /* 부드러운 그림자 */
  transition: background-color 0.3s ease;
}

.nbus_main_header {
  max-width: 1200px; /* 최대 너비 제한 */
  width: 100%;
  height: 100%;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1rem; /* 양옆 여백 */
  box-sizing: border-box;
}

.nbus_main_logo {
  width: 90px;
  height: 80px;
  object-fit: contain;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.nbus_main_nav {
  display: flex;
  gap: 2rem;
}

.nbus_main_nav li {
  list-style: none;
  cursor: pointer;
  font-size: 1rem;
  padding-top: 1.2rem;
  font-family: 'NanumHumanTTFBold';
}

.nbus_nav_bold {
  font-weight: bold;
  color: #000;
}

.nbus_container_1 {
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100vh; /* 화면 높이 기준으로 전체 채우기 */
}

.nbus_container_1_title {
  position: absolute;
  top: 20vh; /* 화면 높이 기준 정확한 위치 */
  left: 50%;
  transform: translateX(-50%); /* 가로만 중앙 정렬 */
  z-index: 2;
  max-width: 90%;
  height: auto;
}

.nbus_title_under_button1_wrap {
  position: absolute;
  top: 50vh; /* 버튼은 아래에 고정 */
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  background-color: #ffcc00;
  color: black;
  text-align: center;
  width: 15rem;
  height: 5rem;
  line-height: 5rem;
  border-radius: 15px;
  transition: all 0.5s;
  cursor: pointer;
  margin-top: 30px;
  font-family: 'NanumHumanTTFBold';
}

.nbus_title_under_button1_wrap:hover {
  background-color: #976200;
  transition: all 0.2s;
  color: #fff;
}


.nbus_main_button_text {
  font-weight: bold;
  font-size: 1.4rem;
}

.nbus_container_1_bg {
  position: relative;
  z-index: 0;
  width: 100%;
  height: 100vh;
  object-fit: cover; /* 비율 유지하며 꽉 채우기 */
}
.nbus_container_2 {
  height: 90vh;
  background: linear-gradient(to bottom, #fff, #ffe270);
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.nbus_container_2_title {
  position: absolute;
  top: 10%;
  left: 50%;
  transform: translateX(-50%);
  max-width: 90%;
  height: auto;
  z-index: 2;
  padding-bottom: 50px;
}

.nbus-box-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 1.5rem;
  width: 80%;
  margin: 5% auto;
  height: 600px;
  padding-top: 10%;
}

.nbus-box {
  width: 100%;
  background-color: white;
  border-radius: 10px;
  padding: 2rem;
  font-size: 1.2rem;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.4s ease;
  opacity: 1;
  visibility: visible;
  cursor: pointer;
}

.nbus-box:hover{
  transition: all 0.4s ease;
  transform: translatey(-10px);
}

.nbus-box.expanded {
  grid-column: 1 / -1;
  grid-row: 1 / -1;
  font-size: 2rem;
  z-index: 2;
}

.nbus-box.hidden {
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
}

.nbus_main_header_wrap.scrolled {
  background-color: #ffcc00 !important;
  transition: background-color 0.3s ease;
  font-weight: 900;
}

.nbus_main_logo.scrolled {
  filter: brightness(0);
}

.floating-object{
  position: absolute;
  width: 10vw;
  height: auto;
  z-index: 10;
  pointer-events: none;
}
.floating-object1{
  animation: float1 3s ease-in-out infinite;
}

/* 각 위치는 조정 가능 (px 단위 고정 위치) */
.obj1 { top: 20%; left: 8%; rotate:-20deg; 
  animation: float1 3s ease-in-out infinite;
}
.obj2 { top: 30%; right: 8%; rotate:10deg; 
  animation: float2 3s ease-in-out infinite;
}
.obj3 { bottom: 8%; left: 8%; rotate:10deg; 
  animation: float3 3s ease-in-out infinite;
}
.obj4 { bottom: 13%; right: 8%;
  animation: float4 10s ease-in-out infinite;
}

/* 둥둥 애니메이션 */
@keyframes float1 {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-12px);
  }
}
@keyframes float2 {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(12px);
  }
}
@keyframes float3 {
  0%, 100% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(15deg);
  }
}
@keyframes float4 {
  0%, 50%,100% {
    transform: scale(1.1);
  }
  25%,75% {
    transform: scale(1);
  }
}

/* 모바일에서는 숨김 처리 */
@media (max-width: 768px) {
  .floating-object {
  width: 20vw;
  z-index: 0;
  }
  .obj1 { top: 32%; left: -5%; rotate:-20deg; 
  animation: float1 3s ease-in-out infinite;
}
.obj2 { top: 40%; right: 1%; rotate:10deg; width: 18%;
  animation: float2 3s ease-in-out infinite;
}
.obj3 { bottom: 25%; left: -3%; rotate:10deg; 
  animation: float3 3s ease-in-out infinite;
}
.obj4 { bottom: 12%; right: 3%; width: 15%;
  animation: float4 10s ease-in-out infinite;
}
}
@media (max-width: 2560px) and (min-width: 1921px) {
  .nbus_container_1_title {
    width: 27%;
  }
  .nbus_container_2_title {
    width: 22%;
  }
  .nbus-box-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, 1fr);
  gap: 1.5rem;
  width: 80%;
  margin: 10% auto;
  height: 600px;
  padding:0;
}
.obj1 { top: 20%; left: 8%; rotate:-20deg; 
  animation: float1 3s ease-in-out infinite;
}
.obj2 { top: 20%; right: 8%; rotate:10deg; 
  animation: float2 3s ease-in-out infinite;
}
.obj3 { bottom: 15%; left: 8%; rotate:10deg; 
  animation: float3 3s ease-in-out infinite;
}
.obj4 { bottom: 19%; right: 8%;
  animation: float4 10s ease-in-out infinite;
}
}

.nbus_container_3 {
  height: 90vh;
  background:#fff;
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 7rem;
  border-bottom: 1px solid #333;
}
.nbus_container_3_left{
  display: flex;
  flex-direction: column;
  align-items: left;
  justify-content: flex-start;
}
.nbus_title_under_button2_wrap{
  background-color: #ffcc00;
  color: black;
  text-align: center;
  width: 20rem;
  height: 5rem;
  line-height: 5rem;
  border-radius: 15px;
  transition: all 0.5s;
  cursor: pointer;
  margin-top: 50px;
  font-family: 'NanumHumanTTFBold';
}
.nbus_container_3_right{
  position: relative;
  background-color: #ffcc00;
  width: 20vw;
  height: 50vh;
  border-radius: 10px;
  background: url(../assets/img/nbus_main/nbus_reservation.jpg)top center no-repeat;
  background-size: cover;
  box-shadow: inset 1px 1px 5px 5px rgba(0,0,0,0.05);
  animation: scrollBg 20s linear infinite;
}
@keyframes scrollBg {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 0 100%;
  }
}
.nbus_container_3_left2{
  margin-top: 50px;
  width: 18vw;
}
.nbus_title_under_button2_wrap:hover {
  background-color: #976200;
  transition: all 0.2s;
  color: #fff;
}
.nbus_container_4 {
  background: #fff;
  padding: 8rem 1rem 5rem;
  text-align: center;
}

.nbus_container_4_inner {
  max-width: 1200px;
  margin: 0 auto;
  text-align: left;
}

.nbus_container_4_inner img {
  max-width: 100%;
  height: auto;
}

.nbus_container_4_inner2 {
  max-width: 1200px;
  margin: 3rem auto 0;
  display: flex;
  justify-content: space-between;
  gap: 2rem;
}

.nbus-box2 {
  background-color: #94cd80;
  border-radius: 10px;
  width: 100%;
  max-width: 360px;
  height: 360px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  transition: all 0.4s ease;
  cursor: pointer;
}

.nbus-box2 img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 10px;
}

.nbus-box2:hover {
  transform: translateY(-10px);
}
.nbus_main_footer{
  height: 40vh;
  width: 100%;
  position: relative;
  background: url(../assets/img/nbus_main/nbus_footer_bg.png) #363636 no-repeat;
  background-size: cover;
}
.nbus_title_under_button3_wrap {
  position: absolute;
  top: 13vh; /* 버튼은 아래에 고정 */
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  background-color: #ffcc00;
  color: black;
  text-align: center;
  width: 20rem;
  height: 4rem;
  line-height: 4rem;
  border-radius: 15px;
  transition: all 0.5s;
  cursor: pointer;
  margin-top: 50px;
  font-family: 'NanumHumanTTFBold';
}
.nbus_title_under_button3_wrap:hover {
  background-color: #976200;
  transition: all 0.2s;
  color: #fff;
}
.nbus_footer_center_img {
  position: absolute;
  top: 5vh; /* 위치 조정 가능 */
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
  text-align: center;
}

.nbus_footer_center_img img {
  width: auto;
  max-width: 60vw;
  height: auto;
}
.nbus_box_mo{
  display: none;
}
@media (max-width: 768px) {
  .nbus_main_nav li {
    font-size: 0.8rem;
  }

  .nbus-box:hover{
  transition: none;
  transform: none;
  }
  .nbus_container_1_title {
    top: 15vh;
    width: 90%;
  }

  .nbus_title_under_button1_wrap {
    top: 45vh;
    width: 90%;
    height: 4rem;
    line-height: 4rem;
    font-size: 1rem;
  }

  .nbus_main_button_text {
    font-size: 1.2rem;
  }

  .nbus-box-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    width: 100%;
    padding: 1rem 0;
    margin-top: 9rem;
    height: auto;
  }
  .nbus_container_2{
    height: 95vh
  }
  .nbus-box {
    width: 90%;
    height: auto;
    padding: 1rem;
  }

  .nbus-box img {
    width: 100%;
  }
  .nbus_container_2_title{
    width: 80%;
  }
  .nbus_container_3 {
    flex-direction: column;
    align-items: center;
    padding: 6rem 1rem 5rem 1rem;
    height: auto;
    gap: 2rem;
  }

  .nbus_container_3_left,
  .nbus_container_3_right {
    width: 100%;
    text-align: center;
    align-items: center;
  }

  .nbus_container_3_left img {
    width: 90%;
  }

  .nbus_container_3_left2 {
    width: 80%;
    margin-top: 2rem;
  }

  .nbus_container_3_right {
    height: 50vh;
  }

  .nbus_title_under_button2_wrap {
    width: 80%;
    height: 4rem;
    line-height: 4rem;
  }
  .nbus_container_4_inner{
    text-align: center;
    width: 100%;
  }
  .nbus_container_4_inner img{
    width: 90%;
    margin:0 auto
  }

  .nbus_container_4_inner2 {
    flex-direction: column;
    align-items: center;
    gap: 2rem;
    max-width: 100%;
  }

  .nbus-box2 {
    width: 100%;
    height: auto;
  }

  .nbus_main_footer {
    height: auto;
    padding-bottom: 3rem;
  }

  .nbus_footer_center_img img {
    max-width: 90vw;
  }

  .nbus_title_under_button3_wrap {
    width: 80%;
    height: 4rem;
    line-height: 4rem;
  }
  .nbus_box_pc{
    display: none;
  }
  .nbus_box_mo{
    display: block;
  }
  .nbus_main_footer{
    height: 40vh;
    width: 100%;
    position: relative;
    background: url(../assets/img/nbus_main/nbus_footer_bg.png) #363636 no-repeat left;
    background-size: cover;
  }
  .nbus_jump_bus{
    width: 40%;
    bottom: 10px;
  }
}
</style>
